// test252
(252 && 0);
